import { env } from './env';

export const featureFlags = {
  get mockApiEnabled(): boolean {
    return env.enableMockApi;
  },

  get debugMode(): boolean {
    return env.env === 'development';
  },

  get queryDevtoolsEnabled(): boolean {
    return env.env === 'development';
  },

  get httpLoggingEnabled(): boolean {
    return env.env === 'development';
  },

  get imageCompressionQuality(): number {
    return env.env === 'development' ? 70 : 85;
  },

  get imageMaxDimension(): number {
    return 1920;
  },

  get imageMaxSizeMB(): number {
    return 2;
  },

  get deepLinkEnabled(): boolean {
    return env.env !== 'development';
  },
} as const;

export type FeatureFlags = typeof featureFlags;
